// extracted by mini-css-extract-plugin
module.exports = {"streamcap":"HeadlineAd__streamcap--2v8yP","instory":"HeadlineAd__instory--FkIVb"};